import { FC, useEffect, useState } from 'react';
import { useAccResultsToken } from '@repository/acc/useAcca';
import { useAccStatusToken } from '@repository/publicAcc/usePublicAcc';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { V2Route } from '@utils/routeUtil/V2Route';
import UrilUtil from '@utils/urlUtil';

const defaultHeight = 1040;

export type RequestPageType = 'check' | 'basic' | 'deep';

interface V3ResultProps {
  requestPage: RequestPageType;
}

const V3Result: FC<V3ResultProps> = ({ requestPage }) => {
  const [height, setHeight] = useState(defaultHeight);
  const { isPublicStore, accaResultStore } = useResultStore();
  const { accResult } = accaResultStore;
  const code = isPublicStore ? UrilUtil.getParamFromUrl().code : accResult?.code;
  const { data: tutorialApplyData } = useAccResultsToken(code ?? '', !isPublicStore);
  const { data: publicApplyData } = useAccStatusToken(code ?? '', isPublicStore);

  const url = isPublicStore ? publicApplyData?.url : tutorialApplyData?.url;
  const token = isPublicStore ? publicApplyData?.token : tutorialApplyData?.token;

  const resizeHeight = (event: MessageEvent) => {
    if (url !== event.origin) return;
    const data = event.data;
    setHeight(data.height);
  };

  useEffect(() => {
    if (!tutorialApplyData && !publicApplyData) return;
    window.addEventListener('message', resizeHeight);

    return () => window.removeEventListener('message', resizeHeight);
  }, [tutorialApplyData, publicApplyData]);

  if (!tutorialApplyData && !publicApplyData) return null;

  return (
    <iframe
      key={token}
      src={V2Route.getAccaV3ResultPage(`${url}`, `${token}`, requestPage)}
      title="acc results"
      style={{ width: '100%', height }}
      frameBorder="no"
      scrolling="no"
    />
  );
};

export default V3Result;
